import { render } from "./m10Final4.vue?vue&type=template&id=72850cb3&scoped=true"
import script from "./m10Final4.vue?vue&type=script&lang=js"
export * from "./m10Final4.vue?vue&type=script&lang=js"

import "./m10Final4.vue?vue&type=style&index=0&id=72850cb3&lang=less&scoped=true"

import exportComponent from "D:\\00project\\36live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72850cb3"]])

export default __exports__